/** @format */

import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

export async function attachZipADM(
  instanceId,
  docId,
  modelId,
  files,
  token,
  fileExtension,
  json = null
) {
  const createDocsResponse = await attachementDocADM(
    instanceId,
    docId,
    token,
    modelId,
    fileExtension
  );

  if (createDocsResponse.statusCode === 200) {
    const presignedUrl = createDocsResponse.message.PresignedURL;
    await uploadDoc(files, presignedUrl).then((response) => {
      return response;
    });
  }
}

async function attachementDocADM(
  instanceId,
  docId,
  token,
  modelId,
  fileExtension
) {
  return await apiRequest(apiURL + "/admin/document/attachment/upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      DocumentId: docId,
      InstanceId: instanceId,
      ModelId: modelId,
      AttachmentType: fileExtension,
    }),
  });
}

// Ne pas migrer vers apiRequest : upload direct vers une URL S3 pré-signée
async function uploadDoc(file, signedUrl) {
  var mypresignedurl = signedUrl;
  var requestOptions = {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": "application/pdf",
      "Content-Length": file.length,
    },
  };

  const response = await fetch(mypresignedurl, requestOptions);
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
}